const BusinessAlertBanner: React.FC<{ setShowBuisinessBanner: Function }> = ({ setShowBuisinessBanner }) => {
  return (
    <div className='business-address mt-4'>
      <div className='business-address-heading'>
        <h2>This seems to be a business address.</h2>
        <span className='close-business'>
          <i className='fa-light fa-xmark-large' onClick={() => setShowBuisinessBanner(false)}></i>
        </span>
      </div>
      <div className='business-address-content'>
        <div className='business-address-business'>
          <div className='d-flex justify-content-center'>
            <span className='fa-solid fa-building location-icon' aria-hidden='true'></span>
          </div>
          <div>
            <h3>Yes, this is a business.</h3>
            <p>Business customers have different rates. Please contact business services to learn more about business plans and pricing.</p>
            <span className='business-phone-number'>
              <span className='fa-solid fa-phone me-2' aria-hidden='true'></span>
              <a href='tel:1-866-889-2667' className='link-primary'>
                1-866-889-2667
              </a>
            </span>
          </div>
        </div>
        <div className='business-address-personal'>
          <div className='d-flex justify-content-center'>
            <span className='fa-solid fa-house location-icon' aria-hidden='true'></span>
          </div>
          <div>
            <h3>This is a personal residence.</h3>
            <p>If this is a personal residence check some of the solutions below.</p>
            <ul className='business-address-bullets'>
              <li>Double check street number and spelling.</li>
              <li>If this is an apartment, add the unit number.</li>
              <li>For best results, please select an address from the dropdown menu.</li>
            </ul>
            <span className='business-phone-number'>
              <span className='fa-solid fa-phone me-2' aria-hidden='true'></span>
              <a href='tel:1-888-403-2667' className='link-primary'>
                1-888-403-2667
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessAlertBanner;
